import React from 'react'
import { UploadIcon } from './UploadIcon'
import app, { api } from 'xadmin'
import { C } from 'xadmin-ui'

const ModelIconPicker = props => {
  const { input: { name, value, onChange }, label, meta, field } = props
  const [icons, setIcons] = React.useState()

  React.useEffect(() => {
    api({ name: 'core/media/systemDefaultIcon' })
      .fetch('', {})
      .then(({ json }) => {
        setIcons(json)
      })
  }, [])

  const ifMedia = app.apps.find(item => item.name === 'iot.media') // 判断是否加载媒体库模块
  return <div style={{ display: 'flex' }}>
    <UploadIcon onChange={onChange} value={value} imgList={icons} iconType={'modelDefaultIcon'} />
    {
      ifMedia && <C
        is='MediaModal'
        uploadHidden
        uploadType='img'
        input={{
          value: value ? '/rest' + value : value,
          onChange: val => {
            if (val) {
              onChange(val?.replace('/rest', ''))
            } else {
              onChange(null)
            }
          }
        }}
      />
    }
  </div>

}

export default ModelIconPicker
